import validator from 'validator';

export function isValidEmail(emailAddress: string) {
    // eslint-disable-next-line no-control-regex
    const ascii = /[^\u0000-\u007F]+/;

    // use the validator js package with an additional check for any remaining non-ascii characters
    return validator.isEmail(emailAddress) && !ascii.test(emailAddress);
}
